import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// ISP storeroom counts. Ordering decisions are made off these numbers, so they
// are never served stale — a count submitted this morning must show up.

export function useIsps() {
  return useQuery({
    queryKey: ['ispStockCounts', 'isps'],
    queryFn: async () => (await api.get('/api/isp-stock-counts/isps')).data.isps,
    staleTime: 0,
    retry: false,
  });
}

export function useIspStockCounts(ispId) {
  return useQuery({
    queryKey: ['ispStockCounts', ispId],
    queryFn: async () => (await api.get('/api/isp-stock-counts', { params: { isp: ispId } })).data,
    enabled: Boolean(ispId),
    staleTime: 0,
    retry: false,
  });
}
